/* TCMX · Motor de movimiento · E5-6 · M5.5-2 (despliegue controlado, 06-sep-2026).
   Solo revela: nunca calcula, nunca escribe importes, nunca toca window.tcmxCalc.
   Un unico IntersectionObserver, sin trabajo continuo durante el scroll, unobserve tras
   revelar (la entrada ocurre UNA sola vez por elemento). */
(function () {
  'use strict';
  if (window.tcmxMov) { return; }
  window.tcmxMov = 1;

  var d = document;
  var raiz = d.documentElement;
  var els = [].slice.call(d.querySelectorAll('[data-mov]'));

  function tok(nombre, porDefecto) {
    var v = parseInt(getComputedStyle(raiz).getPropertyValue(nombre), 10);
    return isNaN(v) ? porDefecto : v;
  }

  /* Al terminar la entrada se marca --fin y se limpia el retraso en linea: a partir de ese
     momento manda la transicion corta del hover, sin heredar el retraso del escalonado. */
  function fin(el) {
    el.style.transitionDelay = '';
    el.classList.add('tcmx-mov--fin');
  }
  function revela(el, retraso) {
    if (el.classList.contains('tcmx-mov--visible')) { return; }
    el.style.transitionDelay = retraso ? retraso + 'ms' : '';
    el.classList.add('tcmx-mov--visible');
    setTimeout(function () { fin(el); }, retraso + tok('--mov-dur', 400) + 80);
  }
  function revelaTodo() {
    for (var i = 0; i < els.length; i++) { revela(els[i], 0); }
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Movimiento reducido, sin soporte o sin elementos: todo visible ya, sin observadores. */
  if (!els.length || reduce || !('IntersectionObserver' in window)) {
    revelaTodo();
    return;
  }

  var TOPE = 6;
  var pendientes = els.slice();
  function atendido(el) {
    var k = pendientes.indexOf(el);
    if (k >= 0) { pendientes.splice(k, 1); }
  }

  var io = new IntersectionObserver(function (entradas, obs) {
    var n = 0;
    var esc = tok('--mov-esc', 60);
    for (var i = 0; i < entradas.length; i++) {
      var e = entradas[i];
      if (!e.isIntersecting) { continue; }
      revela(e.target, Math.min(n, TOPE) * esc);
      n++;
      obs.unobserve(e.target);
      atendido(e.target);
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  for (var i = 0; i < els.length; i++) { io.observe(els[i]); }

  /* Red de seguridad para saltos de scroll (arrastrar la barra, Fin, restaurar posicion):
     si un bloque quedo POR ENCIMA de la pantalla sin llegar a cruzar el umbral, el observador
     no vuelve a avisar. Se revisa una sola vez cuando el scroll se detiene, no durante el
     scroll, y el escucha se retira en cuanto no queda nada pendiente. */
  var reloj = 0;
  function barrer() {
    reloj = 0;
    for (var k = pendientes.length - 1; k >= 0; k--) {
      var el = pendientes[k];
      if (el.getBoundingClientRect().bottom < 0) {
        revela(el, 0);
        io.unobserve(el);
        pendientes.splice(k, 1);
      }
    }
    if (!pendientes.length) { window.removeEventListener('scroll', alScroll); }
  }
  function alScroll() {
    if (reloj) { return; }
    reloj = setTimeout(barrer, 150);
  }
  window.addEventListener('scroll', alScroll, { passive: true });

  /* Enlace con ancla: el bloque destino y lo animable que contenga se ven de inmediato. */
  function porHash() {
    var h = location.hash;
    if (!h || h.length < 2) { return; }
    var t;
    try { t = d.querySelector(h); } catch (err) { return; }
    if (!t) { return; }
    var cont = t.closest ? (t.closest('[data-mov]') || t.parentElement) : t.parentElement;
    var lista = [];
    if (t.hasAttribute('data-mov')) { lista.push(t); }
    if (cont) {
      if (cont.hasAttribute && cont.hasAttribute('data-mov')) { lista.push(cont); }
      lista = lista.concat([].slice.call(cont.querySelectorAll ? cont.querySelectorAll('[data-mov]') : []));
    }
    for (var k = 0; k < lista.length; k++) { revela(lista[k], 0); io.unobserve(lista[k]); atendido(lista[k]); }
  }
  porHash();
  window.addEventListener('hashchange', porHash);

  /* Enfasis del resultado: OBSERVA la cifra ya escrita por la vista de la pagina.
     Cada rejilla de resultados se marca con `data-mov-datos` (M5.5-2: calculadora y comparativa).
     No lee ni recalcula importes; no altera el texto; la cifra nunca desaparece.
     El temporizador vive en la propia celda: tres tarjetas cambian a la vez y una clave
     compartida haria que un clearTimeout cancelara el de otra tarjeta. */
  var rejillas = [].slice.call(d.querySelectorAll('[data-mov-datos]'));
  if (rejillas.length && 'MutationObserver' in window) {
    var mo = new MutationObserver(function (muts) {
      for (var j = 0; j < muts.length; j++) {
        var nodo = muts[j].target;
        var dd = nodo.nodeType === 1 ? nodo : nodo.parentNode;
        if (!dd || dd.nodeType !== 1 || !dd.hasAttribute('data-out')) { continue; }
        dd.classList.add('tcmx-mov-dato--nuevo');
        if (dd.tcmxRetiro) { clearTimeout(dd.tcmxRetiro); }
        (function (celda) {
          celda.tcmxRetiro = setTimeout(function () {
            celda.classList.remove('tcmx-mov-dato--nuevo');
            celda.tcmxRetiro = 0;
          }, 420);
        })(dd);
      }
    });
    for (var g = 0; g < rejillas.length; g++) {
      mo.observe(rejillas[g], { childList: true, characterData: true, subtree: true });
    }
  }
})();
